import React, { Component } from "react";
import { ajaxWrapper } from "functions";

import { Alert } from "library";

export default class SpellTop extends React.Component {
	render() {
		var spell = this.props.spell;

		var ritual = "";
		if (spell.spell_specifics.ritual_cast) {
			ritual = ", Ritual";
		}

		var concentration = "";
		if (spell.spell_specifics.concentration) {
			concentration = ", Concentration";
		}

		var cast_level = null;
		if (this.props.action_use && this.props.action_use.cast_level != spell.level) {
			cast_level = <Alert type="info" text={"Cast at level " + this.props.action_use.cast_level} />;
		}

		//goal: http://www.highprogrammer.com/alan/design/5e-dnd-cards/1original.png
		return (
			<div className="col-12">
				<div className="row" style={{ margin: "0px -15px" }}>
					<div className="col-12">
						{spell.level} level {spell.spell_specifics.magic_school} spell.
					</div>
					<div className="col-12">{cast_level}</div>
					<div className="col-12">
						<br />
					</div>

					<div className="col-6">
						<p>
							<b>Casting Time: </b> {spell.time_to_use}
							{ritual}
						</p>
					</div>
					<div className="col-6">
						<p>
							<b>Range: </b> {spell.range}
						</p>
					</div>
					<div className="col-6">
						<p>
							<b>Components: </b> {spell.spell_specifics.components} ({spell.spell_specifics.material})
						</p>
					</div>
					<div className="col-6">
						<p>
							<b>Duration: </b> {spell.duration}
							{concentration}
						</p>
					</div>
				</div>
			</div>
		);
	}
}
